import React from "react"
import {getWireReceivedPaymentCreditorName, WireReceivedPayment} from "../../resources/receivedPayments"
import {KeyValueCardView} from "../RenderKeyValueCard/KeyValueCardView"
import {Badge} from "../Badge/Badge"
import moment from "moment"
import numeral from "numeral"
import {startCase} from "lodash"
import classNames from "classnames"
import {WireCounterparty} from "../../resources/incomingWire"
import {CounterpartyDetailsCard} from "../CounterpartyDetailsCard/CounterpartyDetailsCard"

interface WireReceivedPaymentDetailsProps {
	wireReceivedPayment: WireReceivedPayment
	/** When provided (e.g. from assignment payload), used for Recipient Details instead of wire attribute */
	receivingEntityName?: string
	/** When provided (e.g. from assignment payload), used for Counterparty in Payment Details instead of companyName */
	sendingEntityName?: string
	disabled?: boolean
	singleColumn?: boolean
	className?: string
	counterparty?: WireCounterparty
}

export function WireReceivedPaymentDetails({
	wireReceivedPayment,
	receivingEntityName: receivingEntityNameOverride,
	sendingEntityName: sendingEntityNameOverride,
	disabled,
	singleColumn,
	className = "default-padding",
	counterparty,
}: WireReceivedPaymentDetailsProps) {
	const receivingEntityName =
		getWireReceivedPaymentCreditorName(wireReceivedPayment, receivingEntityNameOverride) || "N/A"

	const recipientDetails = {
		creditorName: <Badge className={classNames("badge-text", disabled && "disabled")} text={receivingEntityName} />,
	}

	const paymentDetails = {
		amount: numeral(wireReceivedPayment.attributes.amount / 100).format("$0,0.00"),
		createdAt: moment(wireReceivedPayment.attributes.createdAt).format("L h:mm A"),
		direction: startCase(wireReceivedPayment.attributes.direction),
	}

	return (
		<div className="wire-received-payment-details-container">
			<KeyValueCardView
				title="Recipient Details"
				details={recipientDetails}
				singleColumn={singleColumn}
				disabled={disabled}
				className={className}
			/>
			<KeyValueCardView
				title="Payment Details"
				details={paymentDetails}
				singleColumn={singleColumn}
				disabled={disabled}
				className={className}
			/>
			{counterparty && (
				<CounterpartyDetailsCard
					data={{...counterparty, name: sendingEntityNameOverride || counterparty.name}}
					singleColumn
					disabled={disabled}
					className={className}
				/>
			)}
		</div>
	)
}
